import { render, staticRenderFns } from "./panoramaWorld.vue?vue&type=template&id=3510c964&"
import script from "./panoramaWorld.vue?vue&type=script&lang=js&"
export * from "./panoramaWorld.vue?vue&type=script&lang=js&"
import style0 from "./panoramaWorld.vue?vue&type=style&index=0&id=3510c964&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports